import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MapPinIcon, CalendarIcon, CameraIcon, UploadIcon, CheckCircleIcon } from 'lucide-react';
const JURISDICTION_ZIPS = ['20715', '22030', '25401', '20814', '22201', '20001']; // Mock list for MD, VA, WV
export function QuoteWidget() {
  const [step, setStep] = useState(1);
  const [zip, setZip] = useState('');
  const [isJurisdiction, setIsJurisdiction] = useState(false);
  const handleZipSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (zip.length >= 5) {
      // Simple check: if it starts with 2 (common for MD/VA/WV) or in our mock list
      const inArea = zip.startsWith('2') || JURISDICTION_ZIPS.includes(zip);
      setIsJurisdiction(inArea);
      setStep(2);
    }
  };
  return <div className="bg-white border-3 border-charcoal p-6 md:p-8 shadow-[8px_8px_0px_0px_rgba(26,26,26,1)] md:shadow-[12px_12px_0px_0px_rgba(26,26,26,1)]" data-id="element-147">
      <AnimatePresence mode="wait" data-id="element-148">
        {step === 1 && <motion.div key="step1" initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -10
      }} data-id="element-149">
            <h3 className="text-2xl font-bold mb-2" data-id="element-150">Get Your Instant Quote</h3>
            <p className="text-charcoal/60 mb-6 text-sm" data-id="element-151">
              Enter your zip code to see available services in your area.
            </p>
            <form onSubmit={handleZipSubmit} className="space-y-4" data-id="element-152">
              <div className="relative" data-id="element-153">
                <MapPinIcon className="absolute left-4 top-1/2 -translate-y-1/2 text-charcoal/40 w-5 h-5" data-id="element-154" />
                <input type="text" placeholder="Enter Zip Code" className="w-full pl-12 pr-4 py-4 border-2 border-charcoal/10 focus:border-espresso outline-none transition-colors text-lg font-medium" value={zip} onChange={e => setZip(e.target.value.replace(/\D/g, '').slice(0, 5))} required data-id="element-155" />
              </div>
              <button type="submit" className="w-full bg-charcoal text-alabaster py-4 font-bold hover:bg-espresso transition-colors uppercase tracking-widest text-sm" data-id="element-156">
                Check Availability
              </button>
            </form>
          </motion.div>}

        {step === 2 && isJurisdiction && <motion.div key="step2-in" initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} className="space-y-6" data-id="element-157">
            <div className="flex items-center gap-3 text-espresso" data-id="element-158">
              <CheckCircleIcon className="w-6 h-6" data-id="element-159" />
              <span className="font-bold uppercase tracking-wider text-sm" data-id="element-160">
                Technician Available
              </span>
            </div>
            <h3 className="text-2xl font-bold" data-id="element-161">Schedule Your In-Home Survey</h3>
            <p className="text-charcoal/60 text-sm" data-id="element-162">
              A specialist will visit your home in {zip} to provide a precise,
              no-obligation quote.
            </p>

            <div className="border-2 border-charcoal/10 p-4 flex items-center gap-4 cursor-pointer hover:border-espresso transition-colors" data-id="element-163">
              <div className="bg-espresso/10 p-3 rounded-full" data-id="element-164">
                <CalendarIcon className="w-6 h-6 text-espresso" data-id="element-165" />
              </div>
              <div data-id="element-166">
                <p className="font-bold" data-id="element-167">Sync Your Calendar</p>
                <p className="text-xs text-charcoal/40" data-id="element-168">
                  Select a 15-minute window
                </p>
              </div>
            </div>

            <button onClick={() => setStep(1)} className="w-full py-4 border-2 border-charcoal font-bold hover:bg-charcoal hover:text-white transition-all uppercase tracking-widest text-sm" data-id="element-169">
              Book Consultation
            </button>
          </motion.div>}

        {step === 2 && !isJurisdiction && <motion.div key="step2-out" initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} className="space-y-6" data-id="element-170">
            <div className="flex items-center gap-3 text-espresso" data-id="element-171">
              <CameraIcon className="w-6 h-6" data-id="element-172" />
              <span className="font-bold uppercase tracking-wider text-sm" data-id="element-173">
                Remote Quote Ready
              </span>
            </div>
            <h3 className="text-2xl font-bold" data-id="element-174">Upload Your Kitchen Photos</h3>
            <p className="text-charcoal/60 text-sm" data-id="element-175">
              We can provide a custom quote for {zip} based on your photos. Snap
              3 clear angles of your cabinets.
            </p>

            <div className="border-2 border-dashed border-charcoal/20 p-10 flex flex-col items-center justify-center gap-4 bg-alabaster hover:border-espresso transition-colors cursor-pointer group" data-id="element-176">
              <UploadIcon className="w-10 h-10 text-charcoal/20 group-hover:text-espresso transition-colors" data-id="element-177" />
              <p className="text-sm font-medium text-charcoal/40 group-hover:text-charcoal transition-colors" data-id="element-178">
                Drag & Drop or Click to Upload
              </p>
            </div>

            <button onClick={() => setStep(1)} className="w-full bg-espresso text-alabaster py-4 font-bold hover:bg-charcoal transition-colors uppercase tracking-widest text-sm" data-id="element-179">
              Get Remote Quote
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}